import { createAction, props } from '@ngrx/store';

// Generic List Actions
export const loadList = createAction(
  '[List] Load List',
  props<{ listType: string }>()
);

export const loadListSuccess = createAction(
  '[List] Load List Success',
  props<{ listType: string; items: any[] }>()
);

export const loadListFailure = createAction(
  '[List] Load List Failure',
  props<{ listType: string; error: any }>()
);

// Object Load Action (e.g. for profile)
export const loadObjectSuccess = createAction(
  '[Data] Load Object Success',
  props<{ listType: string; data: any }>()
);

// Optional: Track loading state
export const setListLoading = createAction(
  '[List] Set List Loading',
  props<{ listType: string; isLoading: boolean }>()
);
